import { render } from "./MyListFolderDialog.vue?vue&type=template&id=0f5b408b&ts=true"
import script from "./MyListFolderDialog.vue?vue&type=script&lang=ts"
export * from "./MyListFolderDialog.vue?vue&type=script&lang=ts"

import "./MyListFolderDialog.vue?vue&type=style&index=0&id=0f5b408b&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__